import { useCallback } from 'react';
import * as THREE from 'three';

export default function useModel() {
  // const handleGroup = useCallback((group: THREE.Group) => {
  //   if (!!group) {
  //     alignCenterGroup(group);
  //   }
  // }, []);

  // function alignCenterGroup(group: THREE.Group) {
  //   let groupBox = new THREE.Box3().setFromObject(group);
  //   group.translateX(-groupBox.getCenter(new THREE.Vector3()).x);
  //   group.translateY(-groupBox.getCenter(new THREE.Vector3()).y);
  // }

  const addWireFrame = useCallback((mesh: THREE.Mesh) => {
    if (!mesh) return;

    let geo, mat, wireframe;
    geo = new THREE.WireframeGeometry(mesh.geometry); // or WireframeGeometry
    mat = new THREE.LineBasicMaterial({ color: 0x000000 });
    wireframe = new THREE.LineSegments(geo, mat);

    mesh.add(wireframe);
  }, []);

  const removeWireFrame = useCallback((mesh: THREE.Mesh) => {
    mesh.children.forEach(child => {
      if (child instanceof THREE.LineSegments) {
        // mesh에서 자식을 제거합니다.
        mesh.remove(child);
        // geometry와 material을 삭제하여 메모리를 정리합니다.
        child.geometry.dispose();
        child.material.dispose();
      }
    });
  }, []);

  return {
    addWireFrame,
    removeWireFrame,
    // handleGroup,
  };
}
